import React, { useState, useEffect, Fragment } from "react";
import { DownOutlined, EditOutlined, SyncOutlined } from "@ant-design/icons";
import { Popover, Button, Checkbox, Modal, Input, message } from "antd";

import axios from "axios";

axios.defaults.baseURL = "https://api.wonderbits.cn/var";

function ColFilter(props: any) {
  const gerenateFilterList = () => {
    const list: string[] = [];

    if (props.gridSource[props.col]) {
      props.gridSource[props.col].forEach((cell: any) => {
        if (cell && cell.value && !list.includes(cell.value))
          list.push(cell.value);
      });
    }
    list.shift();
    return list;
  };

  const getDefault = () => {
    const find = props.filterList.find((f: any) => {
      return f.col === props.col;
    });
    if (find) {
      if (!find.filters.length) {
        return gerenateFilterList();
      } else {
        return find.filters;
      }
    } else {
      return gerenateFilterList();
    }
  };
  const getDefaultUpdate = () => {
    const find = props.autoUpdateList.find((f: any) => {
      return f.col === props.col;
    });
    if (find) {
      return find.autoUpdate;
    } else {
      return false;
    }
  };
  const [checkedValue, setCheckedValue] = useState<any>(getDefault());
  const [modalVisible, setModalVisible] = useState(false);
  const [title, setTitle] = useState(
    props.displayColNames[props.col] && props.displayColNames[props.col].value
      ? props.displayColNames[props.col].value
      : ""
  );
  const [autoUpdate, setAutoUpdate] = useState(false);

  const doUpdate = async (needMessage = false) => {
    const fieldName = props.gridSource[0][props.col].value;
    const response = await axios.get(`/history?name=${fieldName}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    });

    if (response.data.data.length === 0) {
      message.error("没有这个字段的数据!");
    } else {
      //找到字段数据
      let firstBlank = 0;
      let insertCol = -1;
      let filedExist = false;

      //寻找是否已经存在该列
      props.gridSource.forEach((colData: any, index: number) => {
        if (colData[0].value === fieldName) {
          //找到的情况下
          insertCol = index;
          filedExist = true;
        }
      });

      //结束第一次循环后，如果没找到,则寻找第一列空列
      if (!filedExist) {
        let i = 0;
        while (props.gridSource[i][0].value !== "title") {
          i++;
        }
        firstBlank = i;
      }

      insertCol = insertCol === -1 ? firstBlank : insertCol;

      //更新数据
      const newSource = JSON.parse(JSON.stringify(props.gridSource));

      //数据第一列将列名赋值给value
      const targetCol: any = [
        {
          value: fieldName,
          rowIndex: 0,
          colIndex: insertCol,
          readOnly: true,
          disableEvents: true,
        },
      ];

      response.data.data.forEach((value: string, index: number) => {
        targetCol.push({
          value: value,
          rowIndex: index + 1,
          colIndex: insertCol,
        });
      });

      newSource[insertCol] = targetCol;
      props.setGridSource(newSource);
      if (needMessage) {
        message.success("数据已经刷新");
      }
    }
  };
  const timer = setInterval(async () => {
    if (autoUpdate) {
      doUpdate();
    }
  }, 30000);

  useEffect(() => {
    return () => {
      clearInterval(timer);
    };
  });

  const handleClickOk = () => {
    const filterList = JSON.parse(JSON.stringify(props.filterList));
    const find = filterList.find((filter: any) => {
      return filter.col === props.col;
    });
    if (find) {
      find.filters = checkedValue;
    } else {
      filterList.push({
        col: props.col,
        filters: checkedValue,
      });
    }
    props.setFilterList(filterList);
  };

  const handleClickclear = () => {
    setCheckedValue([]);
  };

  const handleClickEdit = () => {
    setModalVisible(true);
  };

  const handleClickModalOk = () => {
    setModalVisible(false);
    const copy = JSON.parse(JSON.stringify(props.displayColNames));
    if (copy[props.col]) {
      copy[props.col].value = title;
      props.setDisplayColNames(copy);
    } else {
      for (let i = copy.length; i < props.col; i++) {
        copy.push({
          value: "title",
          readOnly: true,
          disableEvents: true,
          mock: true,
        });
      }
      copy.push({
        value: title,
        readOnly: true,
        disableEvents: true,
        mock: true,
      });
      props.setDisplayColNames(copy);
    }
  };

  const handleCheckedAutoUpdate = (e: any) => {
    const autoUpdates = JSON.parse(JSON.stringify(props.autoUpdateList));
    const find = autoUpdates.find((autoUpdate: any) => {
      return autoUpdate.col === props.col;
    });
    if (find) {
      find.autoUpdate = e.target.checked;
    } else {
      autoUpdates.push({
        col: props.col,
        autoUpdate: e.target.checked,
      });
    }
    props.setAutoUpdateList(autoUpdates);
    setAutoUpdate(e.target.checked);
  };

  const handleCheckedAllNumber = (e: any) => {
    if (e.target.checked) {
      const list: string[] = gerenateFilterList();
      const result: any[] = [];
      list.forEach((str) => {
        if (!isNaN(Number(str))) {
          result.push(str);
        }
      });
      setCheckedValue(result);
    } else {
      setCheckedValue(gerenateFilterList());
    }
  };

  const handleCheckedAll = (e: any) => {
    if (e.target.checked) {
      const list: string[] = gerenateFilterList();
      setCheckedValue(list);
    } else {
      setCheckedValue([]);
    }
  };

  const cotent = (
    <div
      style={{ maxHeight: 300, width: 400 }}
      onClick={(e) => {
        e.stopPropagation();
      }}
    >
      <div
        style={{ maxHeight: 270, overflowY: "scroll" }}
        className="col-filter"
      >
        <Checkbox.Group
          options={gerenateFilterList()}
          onChange={(s) => {
            setCheckedValue(s);
          }}
          defaultValue={getDefault()}
          value={checkedValue}
        />
      </div>
      <div style={{ margin: "5px 5px", display: "flex" }}>
        <div style={{ margin: "0px 10px" }}>
          <Button onClick={handleClickclear}>清空</Button>
        </div>
        <div>
          <Button onClick={handleClickOk}>确定</Button>
        </div>
      </div>
    </div>
  );
  return (
    <div>
      {props.children}
      {
        <Fragment>
          <EditOutlined
            style={{ cursor: "pointer", marginLeft: 10 }}
            onClick={handleClickEdit}
          />
          {gerenateFilterList().length === 0 ? (
            ""
          ) : (
            <Popover
              placement="bottom"
              title={
                <div>
                  <Checkbox
                    onChange={handleCheckedAllNumber}
                    defaultChecked={false}
                  >
                    全部数字
                  </Checkbox>
                  <Checkbox onChange={handleCheckedAll} defaultChecked={false}>
                    全选
                  </Checkbox>
                </div>
              }
              content={cotent}
              trigger="click"
            >
              <DownOutlined style={{ cursor: "pointer" }} />
            </Popover>
          )}
        </Fragment>
      }
      {gerenateFilterList().length === 0 ? (
        ""
      ) : (
        <div>
          <div style={{ margin: "0px 20px" }}>
            <Checkbox
              onChange={handleCheckedAutoUpdate}
              defaultChecked={getDefaultUpdate()}
            >
              自动更新
            </Checkbox>
            <SyncOutlined
              onClick={(e) => {
                e.stopPropagation();
                doUpdate(true);
                handleClickOk();
              }}
            />
          </div>
        </div>
      )}
      <Modal
        visible={modalVisible}
        title={"请输入新的列名"}
        onOk={handleClickModalOk}
        onCancel={() => {
          setModalVisible(false);
        }}
      >
        <Input
          placeholder={title}
          size="large"
          onChange={(event: any) => {
            setTitle(event.target.value);
          }}
        ></Input>
      </Modal>
    </div>
  );
}

export default ColFilter;
